import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import { SERVICES } from "../data";

const card = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.6, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] } }),
};

const ServiceCard = ({ s, i }) => {
  const navigate = useNavigate();
  return (
  <motion.div
    custom={i}
    variants={card}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-60px" }}
    data-testid={`service-card-${s.key}`}
    onClick={() => s.route && navigate(s.route)}
    className={`group relative bg-white border-2 border-ink overflow-hidden col-span-full ${s.span} min-h-[220px] flex flex-col justify-between p-6 hover:shadow-hard transition-shadow duration-200 ${s.route ? "cursor-pointer" : ""}`}
  >
    {s.img && (
      <div className="absolute inset-0">
        <img src={s.img} alt={s.title} className="w-full h-full object-cover opacity-100 group-hover:scale-105 transition-transform duration-700" />
        <div className="absolute inset-0 bg-ink/60 group-hover:bg-ink/50 transition-colors" />
      </div>
    )}
    <div className="relative z-10 flex items-start justify-between">
      <div
        className="w-12 h-12 flex items-center justify-center border-2 border-ink"
        style={{ background: s.img ? "#FFDE00" : s.accent, color: s.img ? "#0A0A0A" : (s.accent === "#FFDE00" ? "#0A0A0A" : "#fff") }}
      >
        <s.Icon weight="bold" size={24} />
      </div>
      <ArrowUpRight weight="bold" size={22} className={s.img ? "text-white" : "text-ink/40 group-hover:text-ink"} />
    </div>
    <div className="relative z-10 mt-6">
      <p className={`text-xs font-bold uppercase tracking-[0.2em] mb-1 ${s.img ? "text-sun" : "text-brandred"}`}>{s.tagline}</p>
      <h3 className={`font-display font-extrabold text-2xl tracking-tight leading-tight ${s.img ? "text-white" : "text-ink"}`}>{s.title}</h3>
      <p className={`mt-2 text-sm leading-relaxed ${s.img ? "text-white/80" : "text-ink/60"}`}>{s.desc}</p>
    </div>
  </motion.div>
  );
};

export const Services = () => (
  <section id="services" data-testid="services-section" className="relative py-20 sm:py-28 bg-paper grain">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
      <div className="mb-12 max-w-2xl">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-brandred mb-3">Rides &amp; deliveries</p>
        <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95] text-ink">
          We've got you <span className="text-brandblue">covered.</span>
        </h2>
        <p className="mt-4 text-ink/60 text-base leading-relaxed">
          Everything you need around Windsor — one number does it all.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
        {SERVICES.map((s, i) => (
          <ServiceCard key={s.key} s={s} i={i} />
        ))}
      </div>
    </div>
  </section>
);
